import React, { FunctionComponent, useEffect } from "react";
import { createListTableColumns, GroupedDetailsList } from "sprint-common-web";

import { MovieContentSubtype } from "../../../common/types/MovieContentSubtype";
import { renderAssetTypes } from "../../../common/utils/renderAssetType";
import { getMovieAssetsListHref } from "../../AssetsRoutes";
import { MovieSearchItem } from "./MovieSearchItem";
import { useMovieSearchListPage } from "./useMovieSearchListPage";

export interface MovieSearchListPageProps {
    query: string;
    movieContentType: MovieContentSubtype;
    types: number[];
}

export const MovieSearchListPage: FunctionComponent<MovieSearchListPageProps> = (props: MovieSearchListPageProps) => {
    const { query, movieContentType, types } = props;

    const { movies, totalCount, isLoading, isMoreLoading, pageSize, search, loadMore } = useMovieSearchListPage();

    useEffect(() => {
        search({ query, movieContentType, types });
    }, [query, movieContentType, types]);

    const columns = createListTableColumns<MovieSearchItem>([
        {
            type: "link",
            key: "name",
            name: "Title",
            minWidth: 300,
            maxWidth: 400,
            getHref: (item) => getMovieAssetsListHref(item.id)
        },
        {
            type: "basic",
            key: "distributors",
            name: "Distributors",
            minWidth: 150,
            maxWidth: 650
        },
        {
            type: "basic",
            key: "types",
            name: "Type",
            minWidth: 100,
            maxWidth: 250,
            onRender: renderAssetTypes
        },
        {
            type: "basic",
            key: "assetsCount",
            name: "Active assets count",
            minWidth: 100,
            maxWidth: 100
        }
    ]);

    return (
        <GroupedDetailsList
            items={movies}
            totalItemsCount={totalCount}
            columns={columns}
            isLoading={isLoading}
            loadMoreProps={{ isMoreLoading, pageSize, onLoadMoreClick: loadMore }}
        />
    );
};
